<template>
  <button class="button-user"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false">
    <app-svg :id="hovered ? 'user-hovered' : 'user'"
      width="46"
      height="46" />
  </button>
</template>

<script setup>
import { ref } from 'vue';

const hovered = ref(false);
</script>

<style scoped lang="scss">
.button-user {
  margin-left: 20px;

  svg {
    @include tablet {
      width: 32px;
      height: 32px;
    }
  }

  @include tablet {
    margin-left: 0;
  }
}
</style>
